export const DEFAULT_API_URL = '/api';
export const DEFAULT_TIMEOUT = 300 * 1000;

export const METHOD_CREATE = 'post';
export const METHOD_READ = 'get';
export const METHOD_UPDATE = 'put';
export const METHOD_DELETE = 'delete';

export const OAUTH_CLIENT_ID = '8839b3a138125f41e05542f3c9be2e';
export const OAUTH_CLIENT_SECRET = 'OhegnXr5GDMVsPCrnHArg8ZxR6VAXlrnVtgM81M9';